import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import validateToken from "@/router/validator";
import { saveRedirect } from '@/helpers';

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => !record.meta.public)) {
    if (localStorage.getItem('token') == null) {
      saveRedirect(to.fullPath);
      return next({ path: '/' });
    }
    // Query-only navigations (pagination, filters synced to the URL) stay on the
    // same route the token was already validated for — skip the verify round trip
    if (to.path === from.path) {
      return next();
    }
    return validateToken(next, to);
  }
  return next();
});

// configure router
export default router
